/* istanbul ignore file */
import React from 'react';
import { Button, ButtonColor, ButtonSize, usePopupManager } from 'ui-builder';
import { Button as ShadcnButton } from 'shadcn-ui';
import useFeatureToggleService from 'feature-toggle';

/* eslint-disable react/no-unused-prop-types */
export interface ClosePopupButtonProps {
  text?: string;
  size?: ButtonSize;
  color?: ButtonColor;
  styles?: string[];
  isDisabled?: boolean;
}

function LegacyClosePopupButton(props: ClosePopupButtonProps) {
  const text = props.text || 'Go Back';
  const popupManager = usePopupManager();

  const size = props.size || ButtonSize.BIG;
  const color = props.color || ButtonColor.GRAY;

  return (
    <Button
      text={text}
      onClick={async () => popupManager.closePopup()}
      size={size}
      color={color}
    />
  );
}

function ShadcnClosePopupButton(props: ClosePopupButtonProps) {
  const text = props.text || 'Go Back';
  const popupManager = usePopupManager();

  return (
    <ShadcnButton
      type="button"
      variant="outline"
      onClick={(e) => {
        e.preventDefault();
        popupManager.closePopup();
      }}
    >
      {text}
    </ShadcnButton>
  );
}

export function ClosePopupButton(props: ClosePopupButtonProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnClosePopupButton {...props} />;
  } else {
    return <LegacyClosePopupButton {...props} />;
  }
}
